import { useCallback } from 'react'

import { useNavigation } from '~/hooks/useNavigation'
import { useClearAuth, useServerRequests } from '~/hooks/useRequests'

export const useLogout = () => {
  const navigate = useNavigation()
  const { serverPostRequest } = useServerRequests()
  const clearAuth = useClearAuth()

  const logout = useCallback(() => {
    // Dont await on request, will clear cookie locally, dont need to wait
    // on server
    serverPostRequest({
      path: '/api/auth/logout',
      errorMessage: 'Failed to logout',
    })
    navigate('/')
    clearAuth()
  }, [clearAuth, navigate, serverPostRequest])

  return logout
}
